import {
	ThemeExtensions, LanguageExtensions, Plugins, Keymaps,
} from '@knitiv/code-editor';

export default class ModalQueryAdminController {
	/* @ngInject */
	/**
	 * @param {import('angular').ui.bootstrap.IModalInstanceService} $uibModalInstance
	 * @param {import('~/scripts/services/model/query').default} query
	 */
	constructor($uibModalInstance, query) {
		this.$uibModalInstance = $uibModalInstance;
		this.query = query;
	}

	onEditorReady(editor) {
		this.editor = editor;
	}

	onEditorSetup() {
		return [
			ThemeExtensions.oneLight,
			LanguageExtensions.php(),

			Plugins.FOLD_GUTTERS(),
			Plugins.MATCH_BRACKETS(),
			Plugins.AUTOCOMPLETION(),
			Plugins.CLOSE_BRACKETS(),
			Plugins.DRAW_SELECTION(),
			Plugins.DROP_CURSOR(),
			Plugins.HIGHLIGHT_ACTIVE_LINE_GUTTER(),
			Plugins.HIGHLIGHT_SELECTION_MATCHES(),
			Plugins.HIGHLIGHT_SPECIAL_CHARS(),
			Plugins.HISTORY(),
			Plugins.INDENT_ON_INPUT(),
			Plugins.MULTIPLE_CURSORS(),
			Plugins.RECTANGULAR_SELECTION(),
			Plugins.LINE_NUMBERS(),
			Plugins.KEYMAP.of(Keymaps.KNITIV_KEYMAP),
		];
	}

	close() {
		this.$uibModalInstance.close();
	}
}
